import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ParentMeetingSlot} from '@model/parent-meeting-slot';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import { NgClass, DatePipe, SlicePipe } from '@angular/common';
import {MatTableModule} from '@angular/material/table';

@Component({
    selector: 'app-parent-meeting-slot-list',
    templateUrl: './parent-meeting-slot-list.component.html',
    styleUrls: ['./parent-meeting-slot-list.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTableModule, MatButtonModule, MatIconModule, NgClass, DatePipe, SlicePipe]
})
export class ParentMeetingSlotListComponent implements OnInit { 
  @Input()
  parentMeetingSlots: ParentMeetingSlot[];
  @Input()
  isMobile: boolean;
  @Input()
  readonly: boolean = false;

  @Output()
  parentMeetingSlotBookEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  parentMeetingSlotUnbookEvent: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['date', 'hour', 'student', 'actions'];

  ngOnInit() {
    if (this.readonly) {
      this.displayedColumns = ['date', 'hour', 'student', 'teacher'];
    }
  }

  bookParentMeetingSlot(parentMeetingSlot: ParentMeetingSlot) {
    this.parentMeetingSlotBookEvent.emit(parentMeetingSlot.id);
  }

  unbookParentMeetingSlot(parentMeetingSlot: ParentMeetingSlot) {
    this.parentMeetingSlotUnbookEvent.emit(parentMeetingSlot.id);
  }

  get alreadyBooked(): boolean {
    return this.parentMeetingSlots.some(parentMeetingSlot => parentMeetingSlot.booked && !!parentMeetingSlot.concernedStudentId);
  }
}
